import axios from 'axios';

const api = axios.create({
    baseURL: 'https://back-web3.onrender.com/',
    withCredentials: true,
});

export default api;
